var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('modal',{on:{"close":_vm.close}},[_c('template',{slot:"title"},[_vm._v("Handelsbetingelser")]),_c('template',{slot:"text"},[_c('vHtml',{attrs:{"markdown":_vm.data.content}})],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }